import { useState } from 'react';
import Grid from '@mui/material/Grid2';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { StyledSection, StyledModal } from './StyledCasesGrid';
import USE_CASES from '../data/useCasesData';

const LOREM = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.

Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.

Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet consectetur adipisci velit.`;

function CasesGrid() {
  const [selected, setSelected] = useState(null);

  return (
    <StyledSection>
      <div className="inner">
        
        <Grid container spacing={4}>
          {USE_CASES.map((item) => {
            const { slug, number, actor, summary, Icon } = item;
            return (
              <Grid key={slug} size={{ xs: 12, md: 4 }}>
                <button
                  type="button"
                  className="case-card"
                  onClick={() => setSelected(item)}
                >
                  <div className="case-card__header">
                    <div className="case-card__icon-wrapper">
                      <Icon className="case-card__icon" />
                    </div>
                    <div>
                      <p className="case-card__number">{number}</p>
                      <h3 className="case-card__actor">{actor}</h3>
                    </div>
                  </div>
                  <div className="case-card__divider" />
                  <p className="case-card__desc">{summary}</p>
                </button>
              </Grid>
            );
          })}
        </Grid>
      </div>

      <Dialog
        open={Boolean(selected)}
        onClose={() => setSelected(null)}
        maxWidth="md"
        fullWidth
        scroll="paper"
        slotProps={{ paper: { sx: { borderRadius: '16px', overflow: 'hidden', maxHeight: '85vh' } } }}
      >
        {selected && (
          <StyledModal>
            <div className="modal-header">
              <div className="modal-header__left">
                <div className="modal-header__icon-wrapper">
                  <selected.Icon className="modal-header__icon" />
                </div>
                <div>
                  <p className="modal-header__number">{selected.number}</p>
                  <h2 className="modal-header__title">{selected.actor}</h2>
                </div>
              </div>
              <IconButton className="close-btn" onClick={() => setSelected(null)}>
                <CloseIcon />
              </IconButton>
            </div>
            <DialogContent sx={{ padding: 0, overflowY: 'auto' }}>
              <div className="modal-body">
                {LOREM.split('\n\n').map((para, i) => (
                  <p key={`${i}-${para.slice(0, 20)}`}>{para}</p>
                ))}
              </div>
            </DialogContent>
          </StyledModal>
        )}
      </Dialog>
    </StyledSection>
  );
}

export default CasesGrid;
